import { Formik } from "formik";
import { Integration } from "/app/src/models";
import { simpleSchemaBuilder } from "/app/src/helpers";

import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import RequestForm from "/app/src/components/generic/components/requestForm";
import useSetting from "/app/src/components/settings/setting";
import Box from "/app/src/components/generic/components/box";
import { IconToolTip } from "/app/src/components/icons/IconBuilder";

interface FormValues {
  value: string | undefined;
}

/**
 * Component to display the request settings for a single Data Pull Integration
 * The request settings are the method and body of the request. Current available
 * methods are GET and POST
 */
export default function Request({ integration }: { integration: Integration }) {
  const { t } = useTranslation();

  const { settingValue, createUpdateSetting } = useSetting({
    integrationId: integration.id,
    type: "request",
  });

  const onSubmit = useCallback(
    async (values: FormValues) => {
      await createUpdateSetting({
        ...values,
        type: "request",
        integrationId: integration.id,
      });
    },
    [createUpdateSetting, integration.id],
  );
  const requestBodyContent = useMemo(
    () => (
      <>
        {t("translation:request_body")}
        <IconToolTip
          content={t("translation:request_body_tip")}
          className="ml-1"
        />
      </>
    ),
    [t],
  );
  return (
    <Box>
      <h1>{t("translation:request")}</h1>
      <Formik
        initialValues={{
          value: settingValue,
        }}
        validationSchema={simpleSchemaBuilder([
          { name: "value", type: "string", required: true },
        ])}
        onSubmit={onSubmit}
        enableReinitialize
      >
        <RequestForm label={requestBodyContent} />
      </Formik>
    </Box>
  );
}
